import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=669e398b&scoped=true"
var script = {}
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=669e398b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e398b",
  null
  
)

export default component.exports